
import { Component, Prop } from 'vue-property-decorator';
import { InvoiceApi, InvoiceOpenAmountsResponse, SapInvoice } from '@/api';
import InvoiceStatus from '@/components/invoices/InvoiceStatus.vue';
import getConfiguration from '@/store/getConfiguration';
import DashboardStatusBlock from '../content/blocks/DashboardStatusBlock.vue';

@Component({
  components: { InvoiceStatus },
})
export default class DashboardInvoicesBlock extends DashboardStatusBlock {
  @Prop(Object)
  block!: any;

  fetched = false;

  active = false;

  totals: InvoiceOpenAmountsResponse = {};

  get upcoming(): SapInvoice | undefined {
    return this.totals?.upcoming_invoice;
  }

  async created() {
    try {
      const configuration = await getConfiguration();
      const api = new InvoiceApi(configuration, '');
      const { data } = await api.openAmountInvoicesGet();
      this.totals = data;
      this.active = true;
    } finally {
      this.fetched = true;
    }
  }
}
